const IP4_REGEX = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/

const getDomain = () => {
  if (IP4_REGEX.test(window.location.hostname)) {
    return window.location.hostname
  }

  return window.location.hostname.split('.').splice(1).join('.') || window.location.hostname
}

export default getDomain
